// extracted by mini-css-extract-plugin
export default {"titleNumber":"SubIssueTitle-module__titleNumber__CWmBS60","titleAnchor":"SubIssueTitle-module__titleAnchor__PN_swTA"};